export default __webpack_public_path__ + "static/media/G1.a47e651b.gif";